import { styled } from "@mui/material"
import TextField from "@mui/material/TextField"

export const StyledTextField = styled(TextField as React.FC<any>)`
  width: ${props => props.width || ""};
  height: ${props => props.height || "4em"};
  margin-bottom: 7px;
`
export default StyledTextField
